import { render, staticRenderFns } from "./SystemServiceList.vue?vue&type=template&id=37f86cb2"
import script from "./SystemServiceList.vue?vue&type=script&lang=js"
export * from "./SystemServiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports